import React from 'react'
import PropTypes from 'prop-types'
import { values } from 'lodash/object'
import { withTheme } from 'styled-components'
import { isEmpty } from 'lodash/lang'
import {
  InputBodyWrapper,
  InputError,
  InputInnerLabel,
  InputOuterLabel,
  InputWrapper,
  LeftSideIcon,
  RightSideIcon,
  StyledInput
} from './styles'
import { INPUT_SIZES } from '../../../../const/UIvariants'
import IconButton from '../../Buttons/IconButton'
import usePhoneNumberInput from '../../../../hooks/common/usePhoneNumberInput'

const PhoneNumberInput = ({
  disabled,
  label,
  size,
  inputName,
  rightIconClick,
  rightIcon,
  leftIcon,
  placeholder,
  theme
}) => {
  const { meta, name, onBlur, value, multiple, maskedValue, handleChange } =
    usePhoneNumberInput(inputName)

  return (
    <InputWrapper {...{ size }} error={meta.touched && meta.error}>
      {size === INPUT_SIZES.LARGE ? (
        <InputInnerLabel
          {...{ disabled }}
          htmlFor={name}
          leftPadding={!!leftIcon}
          hidden={isEmpty(value)}
        >
          {label}
        </InputInnerLabel>
      ) : (
        label && (
          <InputOuterLabel
            {...{ disabled }}
            htmlFor={name}
            variant="textS"
            component="label"
          >
            {label}
          </InputOuterLabel>
        )
      )}
      <InputBodyWrapper>
        {leftIcon && (
          <LeftSideIcon style={{ color: value && theme.colors.skyNeutral_1 }}>
            {leftIcon}
          </LeftSideIcon>
        )}
        <StyledInput
          {...{
            name,
            onBlur,
            multiple,
            disabled,
            placeholder,
            size
          }}
          inputmode="numeric"
          type="text"
          maxLength="20"
          onChange={handleChange}
          value={maskedValue}
          leftPadding={!!leftIcon}
          error={meta.touched && meta.error}
        />
        {rightIcon && (
          <RightSideIcon>
            <IconButton onClick={rightIconClick}>
              {React.cloneElement(rightIcon, {
                width: 20,
                height: 20,
                color: theme.colors.skyNeutral2
              })}
            </IconButton>
          </RightSideIcon>
        )}
      </InputBodyWrapper>
      <InputError>{meta.touched && meta.error ? meta.error : null}</InputError>
    </InputWrapper>
  )
}

export default withTheme(PhoneNumberInput)

PhoneNumberInput.defaultProps = {
  rightIconClick: null,
  rightIcon: null,
  leftIcon: null,
  disabled: false,
  placeholder: 'Enter data',
  size: INPUT_SIZES.LARGE,
  type: 'number'
}
PhoneNumberInput.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  rightIconClick: PropTypes.func,
  rightIcon: PropTypes.node,
  leftIcon: PropTypes.node,
  size: PropTypes.oneOf(values(INPUT_SIZES)),
  disabled: PropTypes.bool,
  theme: PropTypes.object.isRequired
}
